import React, { useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import EnquiryForm from './EnquiryForm';
const EnquiryFormContainer = ({ id, container, onWidgetLoaded, propertyCode, channelId, checkIn, checkOut, maxLengthOfStay, minLengthOfStay, childrenEnabled, defaultOccupancy, maxChildAge, minChildAge, maxOccupancy, minOccupancy, language, translations, ipAddress, userAgent, }) => {
    useEffect(() => {
        if (onWidgetLoaded) {
            onWidgetLoaded();
        }
    }, [onWidgetLoaded]);
    return (React.createElement(IntlProvider, { locale: language, messages: translations },
        React.createElement(EnquiryForm, { id: id, container: container, propertyCode: propertyCode, channelId: channelId, language: language, checkIn: checkIn, checkOut: checkOut, maxLengthOfStay: maxLengthOfStay, minLengthOfStay: minLengthOfStay, childrenEnabled: childrenEnabled, defaultOccupancy: defaultOccupancy, maxChildAge: maxChildAge, minChildAge: minChildAge, maxOccupancy: maxOccupancy, minOccupancy: minOccupancy, ipAddress: ipAddress, userAgent: userAgent })));
};
const mapStateToProps = (state) => ({
    propertyCode: state.settings.data.propertyCode,
    channelId: state.settings.data.channelId,
    checkIn: state.settings.data.checkIn,
    checkOut: state.settings.data.checkOut,
    maxLengthOfStay: state.settings.data.maxLengthOfStay,
    minLengthOfStay: state.settings.data.minLengthOfStay,
    childrenEnabled: state.settings.data.childrenEnabled,
    defaultOccupancy: state.settings.data.defaultOccupancy,
    maxChildAge: state.settings.data.maxChildAge,
    minChildAge: state.settings.data.minChildAge,
    maxOccupancy: state.settings.data.maxOccupancy,
    minOccupancy: state.settings.data.minOccupancy,
    language: state.search.data.language,
    ipAddress: state.settings.data.ipAddress,
    userAgent: state.settings.data.userAgent,
    translations: state.translations.data,
});
export default connect(mapStateToProps)(EnquiryFormContainer);
